import { useRef } from 'react';
import { useTranslator } from '@picsart/rc/services/localization';

import InputsSection from '@/components/InputsSection';
import useAuth from '@/hooks/useAuth';
import { useAppStore, type IAppStore } from '@/store';
import isFormValid from '@/utils/isFormValid';

import FeedSheetLayout from '../FeedSheetLayout';
import getSheetCopy from './getSheetCopy';

import type { FeedInputsSheetProps } from './types';

const selector = (store: IAppStore) => ({
  inputs: store.inputs,
  presetType: store.selectedPreset?.type,
});

const FeedInputsSheet = ({
  isOpen,
  isGenerating,
  onGenerate,
  onClose,
}: FeedInputsSheetProps) => {
  const { inputs, presetType } = useAppStore(selector);
  const { isAuthorized, isResolved } = useAuth();
  const translate = useTranslator();
  const uploadSectionRef = useRef<HTMLDivElement>(null);

  const { title, subtitle } = getSheetCopy({ inputs, presetType });
  const showSignIn = isResolved && !isAuthorized;

  return (
    <FeedSheetLayout
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      primaryLabel={translate(showSignIn ? 'Sign in to generate' : 'Generate')}
      isPrimaryDisabled={!(showSignIn || isFormValid(inputs))}
      isPrimaryLoading={isGenerating}
      onPrimaryAction={onGenerate}
      primaryTestId="preset-feed-inputs-sheet-generate"
      cancelTestId="preset-feed-inputs-sheet-cancel"
      ariaLabel={title}
    >
      <InputsSection uploadSectionRef={uploadSectionRef} />
    </FeedSheetLayout>
  );
};

export default FeedInputsSheet;
